import { CardProduct, CardType } from './dzbank-configuration.model';

export type CardProductTexts = {
  cardName: string;
  priceLabel: string;
  completionName: string;
  imageAlt: string;
  imageFilenames: Record<CardType, string>;
};

export const cardProductTexts: Record<CardProduct, CardProductTexts> = {
  [CardProduct.GOLD]: {
    cardName: 'Kreditkarte Gold',
    priceLabel: 'Der Preis der Kreditkarte Gold',
    completionName: 'GoldCard',
    imageAlt: 'Bild Ihrer möglichen neuen Kreditkarte Gold',
    imageFilenames: {
      [CardType.VisaCard]: 'VS_Visa_Gold.png',
      [CardType.MasterCard]: 'VS_Mastercard_Gold.png',
    },
  },
  [CardProduct.CLASSIC]: {
    cardName: 'Kreditkarte Classic',
    priceLabel: 'Der Preis der Kreditkarte Classic',
    completionName: 'ClassicCard',
    imageAlt: 'Bild Ihrer möglichen neuen Kreditkarte Classic',
    imageFilenames: {
      [CardType.VisaCard]: 'VS_Visa_Classic.png',
      [CardType.MasterCard]: 'VS_Mastercard_Classic.png',
    },
  },
  [CardProduct.EXCLUSIVE]: {
    cardName: 'Kreditkarte Exclusive',
    priceLabel: 'Der Preis der Kreditkarte Exclusive',
    completionName: 'ExclusiveCard',
    imageAlt: 'Bild Ihrer möglichen neuen Kreditkarte Exclusive',
    imageFilenames: {
      [CardType.VisaCard]: 'VS_Visa_Exclusive.png',
      [CardType.MasterCard]: 'VS_Mastercard_Exclusive.png',
    },
  },
  [CardProduct.EXCLUSIVE_PLUS]: {
    cardName: 'Kreditkarte Exclusive Plus',
    priceLabel: 'Der Preis der Kreditkarte Exclusive Plus',
    completionName: 'ExclusiveCard Plus',
    imageAlt: 'Bild Ihrer möglichen neuen Kreditkarte Exclusive Plus',
    imageFilenames: {
      [CardType.VisaCard]: 'VS_Visa_ExclusivePlus.png',
      [CardType.MasterCard]: 'VS_Mastercard_ExclusivePlus.png',
    },
  },
};
